import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DisbursmentComponent } from './disbursment.component';

const routes: Routes = [
  {
    path: '',
    component: DisbursmentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisbursmentRoutingModule {}
